<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      sm8
      offset-sm2
      lg4
      offset-lg3
      class="mt-5"
    >
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form
          @submit.prevent="register"
          @keydown="form.onKeydown($event)"
        >
          <v-card-title primary-title>
            <h3 class="headline mb-0">Anmelden als Betrieb</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>

            <p class="subheading">Kostenlose Anmeldung für Innungsbetriebe der teilnehmenden Kreishandwerkerschaften.</p>
            <!-- <p class="subheading">Bei Rückfragen erreichen Sie uns unter folgender Festnetznummer: <br>
              <v-icon small>phone</v-icon> 0201 3200805
            </p> -->
            <!-- Name -->
            <v-text-field
              v-model="form.name"
              label="Ihr Name"
              :v-errors="errors"
              :value.sync="form.name"
              browser-autocomplete="name"
              counter="40"
              name="name"
              data-vv-as="name"
              v-validate="'required|max:40'"
          ></v-text-field>

            <!-- <text-input
              :form="form"
              label="Ihr Name"
              :v-errors="errors"
              :value.sync="form.name"
              browser-autocomplete="name"
              counter="40"
              name="name"
              data-vv-as="Ihr Name"
              v-validate="'required|max:40'"
            ></text-input> -->
            <has-error
              :form="form"
              field="name"
            ></has-error>
<!-- {{  form  }} -->
            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              :error-messages="errors.collect('checkdatenschutz')"
              name="email"
              data-vv-as="Ihre E-Mail"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :form="form"
              :hint="$t('password_length_hint')"
              :v-errors="errors"
              :value.sync="form.password"
              browser-autocomplete="new-password"
              v-on:eye="eye = $event"
              name="password"
              data-vv-as="Ihr Passwort"
              v-validate="'required|min:8'"
              ref="password"
            ></password-input>

            <!-- Password Confirmation -->
            <password-input
              :form="form"
              :hide="eye"
              :label="$t('confirm_password')"
              :v-errors="errors"
              :value.sync="form.password_confirmation"
              browser-autocomplete="new-password"
              data-vv-as="Ihre Passwortbestätigung"
              hide-icon="true"
              name="password_confirmation"
              v-validate="'required|confirmed:password'"
            ></password-input>

          </v-card-text>
          <v-card-text>Bitte fahren Sie nur fort, wenn Sie den unseren Nutzungsbedingungen und unserer Datenschutzerklärung zustimmen.</v-card-text>

          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <submit-button
              :form="form"
              :label="$t('register')"
              block
            ></submit-button>
            <v-spacer></v-spacer>
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>

    <v-flex
      xs12
      offset-xs0
      sm8
      offset-sm2
      lg2
      offset-lg0
    >
      <v-card
        flat
        class="mt-5 ml-2"
      >
        <!-- <v-card-title primary-title>
          <h3 class="subheading mb-0">Kreishandwerkerschaften</h3>
        </v-card-title>
        <v-divider></v-divider> -->
        <v-card-text>

          <v-list dense>
            <v-subheader>Kreishandwerkerschaften</v-subheader>

            <v-list-tile
              v-for="kh in khs"
              :key="kh"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ kh }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
const dict = {
  custom: {
    email: {
      required: 'Bitte eine gültige Email angeben',
      confirmed: 'Bitte eine gültige Email angeben'
    },
    password: {
      confirmed: 'Bitte Passwort bestätigen'
    },
    // name: {
    //   required: 'Bitte einen Namen angeben'
    // }
  }
}

import { Validator } from 'vee-validate'

Validator.localize('de', dict)

import Form from 'vform'

//import TextInput from '~/components/form/TextInput.vue'


export default {
  name: 'register-view',
  metaInfo () {
    return { title: this.$t('register') }
  },
  data: () => ({
    form: new Form({
      name: '',
      email: '',
      password: '',
      password_confirmation: ''
    }),
    eye: true,
    khs: [
      'KH Bochum Ennepe Ruhr',
      'KH Duisburg',
      'KH Düsseldorf',
      'KH Essen',
      'KH Kleve',
      'KH Mettmann',
      'KH Mülheim Oberhausen',
      'KH Münster',
      'KH Recklinghausen',
      'KH Wesel',
      'KH Borken',
      'KH Remscheid'
    ]
  }),
  methods: {
    async register () {
      if (await this.formHasErrors()) {
        console.log('formerror')
        console.log(this.form)
        console.log(data)
        console.log(this.errors.all())
        return
      }
      // Register the user.
      const { data } = await this.form.post('/api/register')
      // Log in the user.
      const {
        data: { token }
      } = await this.form.post('/api/login')
      // Save the token.
      this.$store.dispatch('saveToken', { token })
      // Update the user.
      await this.$store.dispatch('updateUser', { user: data })
      // Redirect home.
      this.$router.push({ name: 'home' })
    }
  }
}
</script>